import { NgxSpinnerService } from 'ngx-spinner';
import { Component, OnInit } from '@angular/core';
import { StripeService, UserInvoiceResponse } from 'src/app/Services/stripe.service';
import { StripeSubscriptionInvoice, Subscription } from 'src/app/models/stripe.model';
import { ConfirmationService } from "primeng/api";
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { NotificationTypes } from 'src/app/app.enums';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-view-user-invoice',
    templateUrl: './view-user-invoice.component.html',
    styleUrls: ['./view-user-invoice.component.css'],
    providers: [StripeService],
    standalone: false
})
export class ViewUserInvoiceComponent implements OnInit {
  public isInvoicesLoaded: boolean = false;
  public userInvoiceDetail!: UserInvoiceResponse;
  public createdDate!: Date;
  public currentPeriod!: string;
  public nextInvoice!: string;
  public subscriptionId!: string;
  public planInterval!: string
  public invoices: StripeSubscriptionInvoice[] = []
  public isFreePlanUser: boolean = false;
  public isActiveSubscription: boolean = false;
  constructor(private stripeService: StripeService,
    private ngxSpinnerService: NgxSpinnerService,
    private confirmationService: ConfirmationService,
    private notificationsService:NotificationsService,
    private router:Router,
    private authService:AuthService,
    private jwtHelper: JwtHelperService,
    private transloco: TranslocoService,
  ) { }

  ngOnInit(): void {
      this.getUserSubscription()
  }

  public getUserSubscription(){
    this.ngxSpinnerService.show();
    this.stripeService.getUserSubscription().subscribe((subscriptionApiResponse: Subscription[]) =>{
      console.log(subscriptionApiResponse)
      if (subscriptionApiResponse) {
        this.createdDate = subscriptionApiResponse[0]?.SubscribedOn;
        this.currentPeriod = subscriptionApiResponse[0]?.CurrentPeriod;
        this.nextInvoice = subscriptionApiResponse[0]?.NextInvoiceOn;
        this.subscriptionId = subscriptionApiResponse[0]?.StripeSubscriptionId;
        this.planInterval = subscriptionApiResponse[0]?.PlanInterval
        this.invoices = subscriptionApiResponse[0]?.StripeSubscriptionInvoices;
        this.isActiveSubscription = subscriptionApiResponse[0]?.IsActiveSubscription
        this.isInvoicesLoaded = true;
        console.log('user subscription invoices' , subscriptionApiResponse);
      } else {
        console.error('Empty subscription response');
      }
      this.ngxSpinnerService.hide()
    }, (error) => { console.error('Error fetching the user Subscription', error); this.ngxSpinnerService.hide(); })
  }

  public onCancelSubscription(subscriptionId: string): void {
    console.log(subscriptionId);

    this.confirmationService.confirm({
      message: this.transloco.translate('viewUserInvoice.cancelSubscriptionConfirm', { planInterval: this.planInterval }),
      accept: () => {
          this.ngxSpinnerService.show();
          this.stripeService.cancelSubscription(subscriptionId).subscribe((response: ResponseObject) => {
              this.ngxSpinnerService.hide();
                    console.log(response);
                    if (response.Success) {
                      this.notificationsService.showNotification(this.transloco.translate('viewUserInvoice.successTitle'), this.transloco.translate('viewUserInvoice.subscriptionCanceledSuccess'), NotificationTypes.Success);
                      // add updated token after cancel subscription
                      this.authService.setAccessToken(response.ResponseData)
                      // Update the isFreePlanUser property
                      // const decodedToken = this.jwtHelper.decodeToken(response.ResponseData);
                      // console.log(decodedToken)
                      // this.isFreePlanUser = this.authService.isFreePlanUser()
                      // if (this.isFreePlanUser) {
                        this.router.navigate(['/dashboard']).then((_)=>{
                              window.location.reload();
                      });
                        
                      // } else {
                      //   // this.isFreePlanUser = !decodedToken?.IsFreeAccount;
                      //   // console.log("isFreePlanUser",this.isFreePlanUser)
                      // }
                    } else {
                      this.notificationsService.showNotification(this.transloco.translate('viewUserInvoice.errorTitle'), this.transloco.translate('viewUserInvoice.failedToCancelSubscription'), NotificationTypes.Error);
                    }
          }, (error) => { console.error(error); this.ngxSpinnerService.hide(); this.notificationsService.showNotification(this.transloco.translate('viewUserInvoice.errorTitle'), this.transloco.translate('viewUserInvoice.errorCancellingSubscription'), NotificationTypes.Error); });
      },
    });
  }
}
